import { toast } from 'react-toastify';
import { t } from 'i18next';
import axiosInstance from '../../axiosInstance';

/**
 * Load file bytes through the same authenticated channel as the rest of the SPA.
 * Plain &lt;img src="/api/files/preview/…"&gt; and &lt;a href&gt; do not send Bearer auth
 * from localStorage, and cross-origin requests may omit cookies — previews/downloads break.
 */

export async function fetchProfileFileObjectUrl(fileId, kind = 'preview') {
  if (fileId == null || fileId === '') {
    throw new Error('missing file id');
  }
  const path = kind === 'download' ? 'download' : 'preview';
  const res = await axiosInstance.get(`/api/files/${path}/${fileId}`, {
    responseType: 'blob',
    suppressErrorToast: true,
  });
  const blob = res.data;
  if (!blob || blob.size === 0) {
    throw new Error('empty file response');
  }
  return URL.createObjectURL(blob);
}

export async function openProfileFilePreviewTab(fileId) {
  try {
    const url = await fetchProfileFileObjectUrl(fileId, 'preview');
    window.open(url, '_blank', 'noopener,noreferrer');
    window.setTimeout(() => URL.revokeObjectURL(url), 180_000);
  } catch (e) {
    toast.error(
      t('profile.filePreviewFailed', {
        defaultValue:
          'Could not preview this file. Try download or check your session.',
      })
    );
    throw e;
  }
}

export async function downloadProfileFileBlob(fileId, filename) {
  try {
    const url = await fetchProfileFileObjectUrl(fileId, 'download');
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `file-${fileId}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    toast.error(
      t('profile.fileDownloadFailed', {
        defaultValue: 'Could not download this file.',
      })
    );
    throw e;
  }
}
